!function webpackUniversalModuleDefinition(e, o) {
  "object" == typeof exports && "object" == typeof module ? module.exports = o() : "function" == typeof define && define.amd ? define([], o) : "object" == typeof exports ? exports["@wordpress/blob"] = o() : (e.wp = e.wp || {}, e.wp.blob = o());
}(self, function () {
  return function () {
    "use strict";

    var e = {};
    return function () {
      var o = e;
      Object.defineProperty(o, "__esModule", {
        value: !0
      }), o.createBlobURL = function createBlobURL(e) {
        var o = t(e);
        return r[o] = e, o;
      }, o.getBlobByURL = getBlobByURL, o.getBlobTypeByURL = function getBlobTypeByURL(e) {
        var o;
        return null === (o = getBlobByURL(e)) || void 0 === o ? void 0 : o.type.split("/")[0];
      }, o.isBlobURL = function isBlobURL(e) {
        if (!e || !e.indexOf) return !1;
        return 0 === e.indexOf("blob:");
      }, o.revokeBlobURL = function revokeBlobURL(e) {
        r[e] && n(e);
        delete r[e];
      };
      var _window$URL = window.URL,
          t = _window$URL.createObjectURL,
          n = _window$URL.revokeObjectURL,
          r = {};

      function getBlobByURL(e) {
        return r[e];
      }
    }(), e;
  }();
});